import { ExpandableResource } from '@shared/components/tree-data-table/expandable-resource';

/**
 * This method returns a collection without affecting the original items since it is specifically built for
 * the way mat-tree works. It also is highly tight to Folder structure(model), it probably wont't work for any
 * other nodes
 * @param collection
 * @param replacement
 */
export const treeNodesReplacer = (
  collection: ExpandableResource<any>[],
  replacement: any
): ExpandableResource<any>[] => {
  return collection.map(treeNodeReplacer.bind(null, replacement));
};

function treeNodeReplacer(replacement: ExpandableResource<any>, item: ExpandableResource<any>) {
  const { childKey } = item;
  if (item.isContainer && item.children) {
    item.setChildren(treeNodesReplacer(item.children, replacement));
  }
  item[childKey] = item.id === replacement.id ? replacement.children : item.children;
  return item;
}
